import React from 'react';
import ReactDOM from 'react-dom/client';
import moment from 'moment';
import { isEmpty } from 'lodash';
import DateFormatter from '../../../app/formatters/DateFormatter';

class Ticket extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tickets: [],
      durationValidity: 12,
      search: {
        id: '',
        uniqNumber: ''
      }
    };
    this.qrCodeInput = React.createRef();
  }

  componentDidMount() {
    var tickets;

    fetch('/api/_ticket', {
      headers: {
        Authorization: 'gestiaweb'
      }
    })
      .then(res => res.json())
      .then(result => {
        tickets = this._addExpirationDate(result.tickets);
        this.setState({
          tickets,
          durationValidity: result.durationValidity,
          search: {
            id: '',
            uniqNumber: ''
          }
        });
      });
  }

  _addExpirationDate(tickets) {
    return tickets.map(ticket => {
      var ticketDate = moment(ticket.createdAt, 'YYYY-MM-DD HH:mm:ss'),
          ticketExpirationDate = moment(ticketDate).add(this.state.durationValidity, 'months');
      
      ticket.expirationDate = ticketExpirationDate.format('DD/MM/YYYY');
      ticket.isExpired = ticketExpirationDate.isSameOrAfter(moment(), 'day') ? false : true;
      
      return ticket;
    });
  }

  /**
   * Pour choisir un autre type de tiquet
   * @param {PointerEvent} e Événement associé au changement de valeur dans la liste déroulante
   */
  selectTicketType(e) {
    this.setState({
      search: {
        id: this.state.search.id,
        uniqNumber: this.state.search.uniqNumber
      }
    });
  }

  /**
   * Pour recherche un tiquet avec son ID
   * @param {PointerEvent} e Événement associé au changement de valeur dans le champ ID
   */
  searchTicketByQrCode(e) {
    var target = /** @type HTMLInputElement}*/(e.target);
    this.setState({
      search: {
        id: target?.value,
        uniqNumber: this.state.search.uniqNumber
      }
    });
  }

  /**
   * Pour recherche un tiquet avec son identifiant unique
   * @param {PointerEvent} e Événement associé au changement de valeur dans le champ identifiant unique
   */
  searchTicketUniqNumber(e) {
    var target = /** @type HTMLInputElement}*/(e.target);
    this.setState({
      search: {
        id: this.state.search.id,
        uniqNumber: target?.value
      }
    });
  }

  /**
   * Lors du focus dans le champ on sélectionne tout le texte, on utilise ce système pour lors du clic sur la validation d'un ticket remettre le focus dans le champ sans éfaccer sa valeur pour voir que l'on a bien validé le ticket
   * @param {PointerEvent} e - Événement associé au focus dans le champs de recherche de ticket par QRCode
   */
  focusOnQrCodeInput(e) {
    var target = /** @type HTMLInputElement}*/(e.target);
    target.select();
  }

  /**
   * Mise à jour d'un ticket lors du clic sur venu ou utilisé
   * @param {object} item Item du ticket à mettre à jour
   * @param {object} updateObj Objet de mise à jour
   */
  updateTicket(item, updateObj) {
    Object.assign(item, updateObj);
    fetch(`/api/update/ticket`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [item],
        property: Object.keys(updateObj)[0],
        modelName: 'ticket'
      })
    })
      .then(res => res.json())
      .then(result => {
        var tickets = this.state.tickets;
        result.forEach(item => {
          let findedItem = tickets.find(ticket => ticket.id === item.id);
          Object.assign(findedItem, item);
        });
        this.setState({
          tickets
        });
        this.qrCodeInput.current.focus();
      });
  }

  /**
   * Suppression d'un ticket
   * @param {object} item - Item du ticket à supprimer
   * @param {PointerEvent} e - Événement associé au clic sur le bouton de suppression
   */
  deleteTicket(item, e) {
    var buttonNode = /** @type {import('../../../jsdoc/bottom.jsdoc').GwView} */(e.target);
    e.preventDefault();

    if(buttonNode) {
      buttonNode.gwView = new Dialog(buttonNode);
    }
  }

  render() {
    var items = this.state.tickets;

    if (this.state.search.id) {
      items = items.filter(item => {
        return item.id === parseInt(this.state.search.id, 10);
      });
    }

    if (this.state.search.uniqNumber) {
      items = items.filter(item => {
        var regExp = new RegExp(this.state.search.uniqNumber, 'g');
        return item.unic_number.match(regExp);
      });
    }

    return (
      <div>
        <div className="flexline flexline--full flexline--margin">
          <input type="text" className="input-group__input" ref={this.qrCodeInput} aria-label="Recherche de ticket via QRCode" placeholder="Recherche de ticket via QRcode" onChange={this.searchTicketByQrCode.bind(this)} onFocus={this.focusOnQrCodeInput.bind(this)} autoFocus />
          <input type="text" className="input-group__input" aria-label="Recherche de ticket via son identifiant unique" placeholder="Recherche de ticket via son identifiant unique" onChange={this.searchTicketUniqNumber.bind(this)} />
        </div>
        <div className="space--16"></div>
        {items.length ? (
          <div className="mosaic mosaic--grid-3">
            {items.map(item => (
              <div key={item.id} className="mosaic__item">
                <div className="mosaic__section">
                  <h4 className="mosaic__title">N°{item.unic_number} - ID : {item.id}</h4>
                  <p className="mosaic__paragraph">Date de création : {DateFormatter.formatDate(item.createdAt)}</p>
                  <p className="mosaic__paragraph">{item.comment}</p>
                  <p className="mosaic__paragraph">{item.ticket_type.name}</p>
                  <div className="mosaic__badges">
                    {item.isExpired ? <div className="mosaic__badge mosaic__badge--danger">Expiré : {item.expirationDate}</div> : <div className="mosaic__badge mosaic__badge--success">Date d'expiration : {item.expirationDate}</div>}
                    {item.is_used && <div className="mosaic__badge mosaic__badge--danger">Déjà utilisé</div>}
                  </div>
                  <div className="mosaic__buttons">
                    {!item.is_used && (
                      <a className="mosaic__button mosaic__button--small mosaic__button--icon" onClick={this.updateTicket.bind(this, item, { is_used: true })} href="#">
                        <span className="material-icons">qr_code_scanner</span>Passer à utiliser
                      </a>
                    )}
                    {item.is_used && (
                      <a className="mosaic__button mosaic__button--small mosaic__button--icon" href={`/_delete/ticket/${item.id}?forcereturnurl=/ticket/_selloruse`} onClick={this.deleteTicket.bind(this, item)}>
                        <span className="material-icons">delete</span>Supprimer
                      </a>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <p className="has-no-entries">
            Nous n'avons pas trouvé ce ticket, assurez-vous qu'il a bien été vendu : <a href={'/_index/ticket?search[id]=' + this.state.search.id}>lançer la recherche ici</a>
          </p>
        )}
      </div>
    );
  }
}

var ticketNode = document.getElementById('ticket');
if (ticketNode) {
  var root = ReactDOM.createRoot(ticketNode);
  root.render(<Ticket />);
}
